import { useStaticQuery, graphql } from "gatsby"

export const useSettings = () =>
  useStaticQuery(graphql`
    query SANITY_SETTINGS {
      appearance: sanitySettingAppearance {
        themeDisplay
        themeColour {
          hex
        }
        themeBgColour {
          hex
        }
      }
      languages: sanitySettingLanguages {
        hrefLangs: languages {
          _key
          language
          region
          url
        }
      }
      organisation: sanitySettingOrganisation {
        title
        description
        author
        logo {
          asset {
            url
          }
        }
        addressLocality
        addressRegion
        postalCode
        streetAddress
        separator
        url
      }
      scripts: sanitySettingScripts {
        trackingHeader {
          code
        }
        trackingBody {
          code
        }
        trackingFooter {
          code
        }
      }
      social: sanitySettingSocial {
        instagramAccessToken
        instagramClientID
        instagramUsername
        channels {
          title
          url
        }
      }
      tracking: sanitySettingTracking {
        googleTagManagerId
        googleSiteVerify
        googleAnalyticsId
        facebookPixelId
        facebookAppId
      }
      subscribeFooter: sanitySettingSubscribe {
        footerTitle
        footerContent: _rawFooterContent(resolveReferences: { maxDepth: 2 })
        footerSuccessMessage: _rawFooterSuccessMessage(resolveReferences: { maxDepth: 2 })
      }
    }
  `)
